/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AnnualDeductible from './AnnualDeductible/index'
import CoordinatedCoverage from './CoordinatedCoverage/index'
import Downpayment from './Downpayment/index'
import DownpaymentAmount from './DownpaymentAmount/index'
import EffectiveFrom from './EffectiveFrom/index'
import EstimatedReimbursement from './EstimatedReimbursement/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import InNetworkDiscount from './InNetworkDiscount/index'
import InProgress from './InProgress/index'
import InstallmentAmount from './InstallmentAmount/index'
import LossDueToAgeLimit from './LossDueToAgeLimit/index'
import LossDueToEffectiveDate from './LossDueToEffectiveDate/index'
import MaximumLifetimeCoverage from './MaximumLifetimeCoverage/index'
import PatientAgeLimit from './PatientAgeLimit/index'
import PreviouslyUsed from './PreviouslyUsed/index'
import React from 'react'
import ReimbursementDeductions from './ReimbursementDeductions/index'
import ReimbursementRate from './ReimbursementRate/index'
import RemainingAfterInsurance from './RemainingAfterInsurance/index'
import RemainingCoverage from './RemainingCoverage/index'
import SaveAction from './SaveAction/index'
import TotalDeductible from './TotalDeductible/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import Tysiav2InsuranceSubscription from 'DesignSystem/Svgs/Tysiav2InsuranceSubscription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/EditAction/Content/Edit/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let insuranceInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'insured.insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="large"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
 justifyContent="flex-start"
>
{childProps => (
<React.Fragment>
<Tysiav2InsuranceSubscription
{...childProps}
  viewPath={`${viewPath}/Tysiav2InsuranceSubscription`}
/>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 marginLeft={dtSpaceXs}
 data="insurance.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 text={insuranceInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData}
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 marginLeft="auto"
/>
</React.Fragment>
)}
</TysiaModalHeader>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-6-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-7-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
>
<InNetworkDiscount
  viewPath={`${viewPath}/InNetworkDiscount`}
/>
<ReimbursementRate
  viewPath={`${viewPath}/ReimbursementRate`}
/>
<RemainingCoverage
  viewPath={`${viewPath}/RemainingCoverage`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<ReimbursementDeductions
  viewPath={`${viewPath}/ReimbursementDeductions`}
/>
<TotalDeductible
  viewPath={`${viewPath}/TotalDeductible`}
/>
<LossDueToAgeLimit
  viewPath={`${viewPath}/LossDueToAgeLimit`}
/>
<LossDueToEffectiveDate
  viewPath={`${viewPath}/LossDueToEffectiveDate`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<EstimatedReimbursement
  viewPath={`${viewPath}/EstimatedReimbursement`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
/>
<RemainingAfterInsurance
  viewPath={`${viewPath}/RemainingAfterInsurance`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-5-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-6-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--blc-8-Z1Yf8zk': dtColorsNeutral200,'--pt-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-6-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<MaximumLifetimeCoverage
  viewPath={`${viewPath}/MaximumLifetimeCoverage`}
/>
<PreviouslyUsed
  viewPath={`${viewPath}/PreviouslyUsed`}
/>
<AnnualDeductible
  viewPath={`${viewPath}/AnnualDeductible`}
/>
<EffectiveFrom
  viewPath={`${viewPath}/EffectiveFrom`}
/>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
<DownpaymentAmount
  viewPath={`${viewPath}/DownpaymentAmount`}
/>
<InstallmentAmount
  viewPath={`${viewPath}/InstallmentAmount`}
/>
<PatientAgeLimit
  viewPath={`${viewPath}/PatientAgeLimit`}
/>
<InProgress
  viewPath={`${viewPath}/InProgress`}
/>
<CoordinatedCoverage
  viewPath={`${viewPath}/CoordinatedCoverage`}
/>
</div>
</div>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}